export const portalBoxContainer = () =>
  `w-220 h-232 relative rounded-2xl border border-elr-green border-opacity-30 px-7 pt-10 cursor-pointer m-5`;
